export type ResourceType = 'html' | 'pdf' | 'image' | 'video' | 'link';

export interface Resource {
  id: string;
  title: string;
  type: ResourceType;
  fileUrl: string;
  category: string;
}
